const originalRemoveChild = Node.prototype.removeChild;
const originalInsertBefore = Node.prototype.insertBefore;

function patchedRemoveChild<T extends Node>(this: Node, child: T): T {
  if (child.parentNode !== this) {
    if (child.parentNode) {
      return originalRemoveChild.call(child.parentNode, child) as T;
    }
    return child;
  }
  return originalRemoveChild.call(this, child) as T;
}

function patchedInsertBefore<T extends Node>(
  this: Node,
  newNode: T,
  referenceNode: Node | null
): T {
  if (referenceNode && referenceNode.parentNode !== this) {
    return originalInsertBefore.call(this, newNode, null) as T;
  }
  return originalInsertBefore.call(this, newNode, referenceNode) as T;
}

export function applyDomPatches(): void {
  if (typeof Node !== 'undefined') {
    Node.prototype.removeChild = patchedRemoveChild;
    Node.prototype.insertBefore = patchedInsertBefore;
  }
}
